import type { DocumentLayoutBlock } from "../documentAppearance/documentAppearanceApi";
import type { DocumentBlockOverrides, EffectiveSystemDocumentTextDto } from "./systemDocumentApi";

type PreviewTextField = "salutation" | "introduction" | "notice" | "closing";

const previewTextFields = new Set<string>(["salutation", "introduction", "notice", "closing"]);

/**
 * Liefert den Rohtext, über den der Editor nur die Musterwerte legt. Der bereits zusammengeführte
 * Baustein gehört vor das alte Feldmodell: Andernfalls überschreibt dessen ausgelieferter Standard
 * einen ausdrücklich im Erscheinungsbild gepflegten Text nach dem Server-Render erneut.
 */
export function systemDocumentPreviewValueSource(
  block: DocumentLayoutBlock | null,
  field: string | null,
  activeOverrides: DocumentBlockOverrides,
  texts: EffectiveSystemDocumentTextDto,
): string | null {
  if (field == null) return null;

  const overridden = block?.key == null ? null : activeOverrides.blocks[block.key]?.text;
  if (overridden != null) return overridden;
  if (block?.text != null) return block.text;
  return previewTextFields.has(field) ? texts[field as PreviewTextField] : null;
}
